import classNames from 'classnames';
import {
  TEMPLATE_LIST_ACTIONS_GAP,
  TEMPLATE_LIST_ROW_HEIGHT,
} from 'modules/manager/ui/components/media-manager-template-list-element';
import React from 'react';

/** Ширины плашек под имя шаблона — порядок величин реальных имён («Расписание (копия)» — 131px). */
const NAME_WIDTHS = [180, 240, 150, 210, 170, 230];

/** Высота подписи `UDText body-2` в строке — снята в браузере. */
const NAME_HEIGHT = 15;

/** Иконки действий строки: «Скачать», «Редактировать», «Удалить» — по 20px. */
const ACTION_ICONS_COUNT = 3;

interface TemplateListSkeletonProps {
  /** Сколько строк нарисовать. */
  count?: number;
}

/**
 * Тело `ListView` списка шаблонов на время загрузки.
 *
 * Повторяет `MediaManagerTemplateListElement`: строка той же высоты с тем же
 * `border-l-4 p-2` и тем же чередованием фона, слева плашка под имя, справа три
 * квадрата 20px с тем же шагом. Поэтому при появлении данных имя и иконки встают
 * ровно на места плашек.
 */
export const TemplateListSkeleton: React.FC<TemplateListSkeletonProps> = ({ count = NAME_WIDTHS.length }) => (
  <div className="h-full w-full bg-white" data-testid="template-list-skeleton" aria-hidden>
    {Array.from({ length: count }, (_, index) => (
      <div
        key={index}
        className={classNames('flex items-center justify-between border-l-4 border-transparent p-2', {
          'bg-white': index % 2 === 0,
          'bg-BorderGray50': index % 2 === 1,
        })}
        style={{ height: TEMPLATE_LIST_ROW_HEIGHT }}
      >
        <div className="skeleton-block" style={{ width: NAME_WIDTHS[index % NAME_WIDTHS.length], height: NAME_HEIGHT }} />
        <div className="flex" style={{ gap: TEMPLATE_LIST_ACTIONS_GAP }}>
          {Array.from({ length: ACTION_ICONS_COUNT }, (__, icon) => (
            <div key={icon} className="skeleton-block size-5" />
          ))}
        </div>
      </div>
    ))}
  </div>
);

export default TemplateListSkeleton;
